import { useCallback } from "react";
import { useCachedQuery } from "./useCachedQuery";
import { fetchToolCallHistory, type TenantToolCallHistory } from "./useAdminStatus";
import { instanceToolCallsResource } from "../lib/adminQueries";
import { rangeToWindowHours, type InstanceRange } from "../lib/instanceDetailRange";

export type InstanceToolCallsResult = {
  status: "loading" | "ready" | "error";
  history: TenantToolCallHistory | null;
  error: string | null;
  isFetching: boolean;
};

export const useInstanceToolCalls = (tenantId: string, range: InstanceRange): InstanceToolCallsResult => {
  const hours = rangeToWindowHours(range);
  const fetcher = useCallback(
    (signal: AbortSignal): Promise<TenantToolCallHistory> => fetchToolCallHistory(tenantId, hours, signal),
    [tenantId, hours],
  );
  const { status, data, error, isFetching } = useCachedQuery<TenantToolCallHistory>({
    cacheResource: range === "24h" ? instanceToolCallsResource(tenantId) : null,
    queryKey: `/api/admin/claws/${tenantId}/tool-calls/timeline?hours=${hours}`,
    fetcher,
  });
  return { status, history: data, error, isFetching };
};
